import ScreenSizeDebugger from "./ScreenSizeDebugger";
import AlignLines from "./AlignLines";
import ContenfulQuickLink from "./ContenfulQuickLink";

function DebuggerTools() {
	return (
		<>
			{/* DEBUGGER TOOLS */}
			{process.env.APP_ENV === "development" && (
				<>
					{/* Debugging Tools */}
					<ScreenSizeDebugger />
					{/* <AlignLines /> */}
				</>
			)}

			{/* STAGING TOOLS */}
			{process.env.APP_ENV !== "production" && <ContenfulQuickLink title="Page Link" />}
		</>
	);
}
export { ScreenSizeDebugger, AlignLines, ContenfulQuickLink, DebuggerTools };
